import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {Theme} from "@mui/material/styles";
import {createStyles, makeStyles} from "@mui/styles";
import {GridColDef} from "@mui/x-data-grid";
import React, {useState} from "react";
import {UserGroupMemberDto} from "../../../../../common/apis/usergroup/UserGroupMemberDto";
import Grid from "../../../../../components/dialogs/Grid";
import ExtGridWrapper from "../../../../../components/grid/ExtGridWrapper";
import {ActionButtonType, EnabledPolicy, GridAction} from "../../../../../components/grid/GridAction";
import SectionHeader from "../../../../../components/section/SectionHeader";
import {PersistentStateId} from "../../../../../store/common/Grid";
import {t} from "../../../../../store/localization/TranslMessasge";
import {ButtonId} from "../ButtonId";
import {useFindAllUserGroupMembersQuery} from "../UserGroupQuery";
import {UserGroupsTranslationKey} from "../UserGroupsTranslationKey";
import UserGroupMemberAddDialog from "./UserGroupMemberAddDialog";
import UserGroupMemberDeleteDialog from "./UserGroupMemberDeleteDialog";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grid: {
            minHeight: "18em",
        }
    })
);

interface UserGroupMemberPanelProps {
    groupId: string;
}

export default function UserGroupMemberPanel({groupId}: Readonly<UserGroupMemberPanelProps>) {
    const classes = useStyles();
    const {data: members} = useFindAllUserGroupMembersQuery(groupId);

    const [addMemberDialogOpen, setAddMemberDialogOpen] = useState(false);
    const [selectedUserLogin, setSelectedUserLogin] = useState<string | undefined>();
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const columns: GridColDef<UserGroupMemberDto>[] = [
        {field: 'login', headerName: t(UserGroupsTranslationKey.LOGIN), width: 200},
        {field: 'firstName', headerName: t(UserGroupsTranslationKey.FIRST_NAME), width: 200},
        {field: 'lastName', headerName: t(UserGroupsTranslationKey.LAST_NAME), width: 200},
        {field: 'email', headerName: t(UserGroupsTranslationKey.EMAIL), width: 250},
    ];

    return (
            <>
                <Grid container>
                    <Grid item xs={12}>
                        <SectionHeader title={t(UserGroupsTranslationKey.MEMBERS)}/>
                    </Grid>
                    <Grid item xs={12}>
                        <ExtGridWrapper
                                columns={columns}
                                rows={members ?? []}
                                rowCount={members?.length ?? 0}
                                getRowId={row => row.login}
                                dataGridClass={classes.grid}
                                actions={[
                                    GridAction.buttonBuilder(ButtonId.ADD_MEMBER, ActionButtonType.IMMEDIATE, t(UserGroupsTranslationKey.ADD_MEMBER),
                                            <AddIcon/>)
                                            .enabledPolicy(EnabledPolicy.ALWAYS)
                                            .onClick(() => setAddMemberDialogOpen(true))
                                            .build(),
                                    GridAction.buttonBuilder(ButtonId.REMOVE_MEMBER, ActionButtonType.IMMEDIATE, t(UserGroupsTranslationKey.REMOVE_MEMBER),
                                            <DeleteIcon/>)
                                            .enabledPolicy(EnabledPolicy.WHEN_EXACTLY_ONE_SELECTED)
                                            .onClick((selectedRowIds) => {
                                                setSelectedUserLogin(selectedRowIds[0] as string);
                                                setDeleteDialogOpen(true);
                                            })
                                            .build(),
                                ]}
                                peristentStateId={PersistentStateId.USER_GROUP_DETAIL_MEMBERS_GRID}
                                resourceId={"userGroupMembers"}
                        />
                    </Grid>
                </Grid>

                <UserGroupMemberAddDialog
                        open={addMemberDialogOpen}
                        groupId={groupId}
                        onClose={() => setAddMemberDialogOpen(false)}/>

                {selectedUserLogin &&
                        <UserGroupMemberDeleteDialog
                                open={deleteDialogOpen}
                                groupId={groupId}
                                userLogin={selectedUserLogin}
                                onClose={() => setDeleteDialogOpen(false)}/>
                }
            </>
    );
}
